// import React, { useContext, useState } from "react";
import TrustedWorkersEmployeeList from "./trusted-worker-employee-list";
// import { JobDetailsContext } from "../job-detail1";
// import { useSelector } from "react-redux";

const TrustedWorkersEmployeeTabs = () => {
  // const { userInfo, role_type } = useSelector((state) => state.menu);
  // const { jobDetailsInfo } = useContext(JobDetailsContext);
  // const [activeTab, setActiveTab] = useState(() => {
  //   if (
  //     jobDetailsInfo?.isTrustedWorkerOnly &&
  //     !jobDetailsInfo?.isEmployeeOnly
  //   ) {
  //     return "trusted-worker";
  //   }
  //   return "employee";
  // });

  // const handleTabChange = (tab) => {
  //   setActiveTab(tab);
  // };

  // console.log("TrustedWorkersEmployeeTabs=====", jobDetailsInfo);

  return (
    <>
      <div className="twm-tabs-style-2">
        {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
        {
          jobDetailsInfo?.isEmployeeOnly &&
            (role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
              role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN") ||
              userInfo?.institutionId === jobDetailsInfo?.institutionEntityId) && (
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "employee" ? "active" : ""
                  }`}
                  data-bs-toggle="tab"
                  data-bs-target="#sign-employees"
                  type="button"
                  onClick={() => handleTabChange("employee")}
                >
                  <i className="fa fa-user-friends" /> Employees
                </button>
              </li>
            )}

          {
            jobDetailsInfo?.isTrustedWorkerOnly &&
              ((role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) ||
               (userInfo?.institutionId ===
                  jobDetailsInfo?.institutionEntityId)) && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "trusted-worker" ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                    data-bs-target="#sign-trusted-workers"
                    type="button"
                    onClick={() => handleTabChange("trusted-worker")}
                  >
                    <i className="fa fa-users" /> Trusted Workers
                  </button>
                </li>
              )
          }
          {
            jobDetailsInfo?.isTrustedWorkerOnly &&
              ((role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN"))) && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "all-workers" ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                    data-bs-target="#sign-all-workers"
                    type="button"
                    onClick={() => handleTabChange("all-workers")}
                  >
                    <i className="fa fa-users" /> All Workers
                  </button>
                </li>
              )
          }
        </ul> */}

        <div className="tab-content" id="myTab2Content">
          {/* <TrustedWorkersEmployeeList activeTab={activeTab} /> */}
          <TrustedWorkersEmployeeList />
        </div>
      </div>
    </>
  );
};

export default TrustedWorkersEmployeeTabs;
